import React, { useState } from 'react';
import { Accordion } from './Accordion';
export function ModuloProfesional() {
  const [openIndex, setOpenIndex] = useState<number>(-1);
  const modulos = [{
    icon: '🏥',
    title: 'Módulo Salud',
    items: 'Anatomía · Tipos de dolor · Farmacología · Salud mental · Ginecología · Pediatría · Protocolo de mala noticia'
  }, {
    icon: '🏫',
    title: 'Módulo Educación',
    items: 'Consignas de examen · Psicopedagogía · Nivel secundario y terciario · Kit de emergencia docente'
  }, {
    icon: '🏦',
    title: 'Módulo Banca y Comercio',
    items: 'Vocabulario bancario · Inversiones · Seguros · RRHH · Impositivo'
  }, {
    icon: '⚖️',
    title: 'Módulo Legal',
    items: 'Sistema judicial · Delitos y denuncias · Derechos de personas sordas · CUD · ANSES · Mediación'
  }];
  return <section className="bg-lsa-dark text-white py-12 px-5 border-t border-white/10" data-id="element-125">
      <div className="max-w-xl mx-auto" data-id="element-126">
        <div className="flex justify-center mb-6" data-id="element-127">
          <div className="bg-lsa-cyan text-lsa-deep rounded-full px-4 py-1.5 text-xs font-bold tracking-wide flex items-center gap-2 shadow-lg shadow-lsa-cyan/20" data-id="element-128">
            <span data-id="element-129">⭐</span> Exclusivo del Plan Profesional
          </div>
        </div>

        <h2 className="text-[28px] font-bold text-center mb-3 leading-tight" data-id="element-130">
          LSA en tu trabajo. Sin improvisar.
        </h2>
        <p className="text-center text-white/80 text-[15px] mb-10 max-w-md mx-auto" data-id="element-131">
          Para profesionales que atienden personas sordas y necesitan
          vocabulario técnico real.
        </p>

        <div className="mb-8" data-id="element-132">
          {modulos.map((mod, index) => <Accordion key={index} theme="dark" isOpen={openIndex === index} onToggle={() => setOpenIndex(openIndex === index ? -1 : index)} title={<div className="flex items-center gap-3" data-id="element-134">
                  <span className="text-xl" data-id="element-135">{mod.icon}</span>
                  <span data-id="element-136">{mod.title}</span>
                </div>} data-id="element-133">
              <div className="pt-2 pb-2" data-id="element-137">
                <p className="text-[14px] text-white/80 leading-relaxed" data-id="element-138">
                  {mod.items}
                </p>
              </div>
            </Accordion>)}
        </div>

        <div className="bg-white/5 border border-white/10 rounded-xl p-4 text-center text-[14px] text-white/90" data-id="element-139">
          <span className="font-semibold text-lsa-celeste" data-id="element-140">
            También incluye:
          </span>{' '}
          Certificado de especialización · Protocolo de recepción profesional
        </div>
      </div>
    </section>;
}